import { cn } from '@shared/lib/utils';
import { resolveNetworkIconSrc } from '../lib/network-icons';

interface InvoiceNetworkRowProps {
  networkCode: string;
  networkLabel: string;
  className?: string;
}

/** Network mark + label under crypto amount (icon is decorative; label carries the name). */
export function InvoiceNetworkRow({ networkCode, networkLabel, className }: InvoiceNetworkRowProps) {
  const iconSrc = resolveNetworkIconSrc(networkCode) ?? resolveNetworkIconSrc(networkLabel);

  return (
    <div className={cn('flex items-center gap-2', className)}>
      {iconSrc ? (
        <img
          src={iconSrc}
          alt=""
          width={20}
          height={20}
          className="size-5 shrink-0 dark:invert"
          aria-hidden
        />
      ) : null}
      <span className="font-sans text-lg font-semibold tracking-normal text-base-foreground">
        {networkLabel}
      </span>
    </div>
  );
}
